<script>
 import router from "page";
 import Map from './Map.svelte';
 import Mill from './Mill.svelte';
 import Company from './Company.svelte';
 import List from './List.svelte';
 import LitShop from './LitShop.svelte';
 import LitCart from './LitCart.svelte';
 export let ready;

 let page, params;

 router('/buyers-guide', function () { page = List });
 router('/buyers-guide/:mill',
   function(ctx, next) { params = ctx.params; next(); },
   function() { page = Mill }
 );
 router('/buyers-guide/company/:company',
   function(ctx, next) { params = ctx.params; next(); },
   function() { page = Company }
 );
 router('/resources/publications-listing', function() { page = LitShop });
 router('/resources/publications-cart', function() { page = LitCart });
 router.start();
</script>

<svelte:head>
  <script defer async
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyC1lJQcAk0_O8gigUc43fV4HaQpXCf9lUk&callback=initMap">
  </script>
</svelte:head>

<svelte:component this={page} params={params} ready={ready} />
